export default __webpack_public_path__ + "static/media/teleco.d6799edf.jpg";